<input hidden="" (change)="handleInputChange($event)" id="attachment_files" type="file" accept="image/*">
<label for="attachment_files" class="w-100">
    <div appDnd (filesChangeEmitter)="onFilesChange($event)" (filesInvalidEmitter)="onFileInvalids($event)" class="drop-box" tabindex="0">
    <div class="overlay"></div>
    <span *ngIf="!imageData"><div class="preview"><p>{{placeholderText ? placeholderText : ('common.selectAnImage' | translate) }}</p></div></span>
    <label for="attachment_files">
        <span class="helper"></span><img *ngIf="imageData" class="preview" (error)="imageNotFound()" [src]="imageData"/>
    </label>
    </div>
</label>